/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../../components/controls/hideInput/converters/email.converter.ts"/>
///<reference path="../../components/controls/hideInput/converters/phone.converter.ts"/>


module Meevo.Plugins.SelfCheckInKiosk {
    import ISelfCheckInKioskSettingsModel = Meevo.Plugins.SelfCheckInKioskSettings.ISelfCheckInKioskSettingsModel;

    export class SelfCheckInKioskLogic {

        private _clientIds: string[];
        private _kioskSettings: ISelfCheckInKioskSettingsModel;
        private lateCheckInMin: number;

        public clientPhone: string;
        public clientEmail: string;
        public readonly promotionImagesSrc: string[];
        public promotionImagesSrcx2: string[];
        public promotionImagesSrcx3: string[];
        public clientDataToCheckin: IDataToCheckInEntity[];
        public enhancementsCount: number;

        get clientIds(): string[] {
            return this._clientIds;
        }

        get kioskSettings(): ISelfCheckInKioskSettingsModel {
            return this._kioskSettings;
        }

        static factory(): Function {
            const instance = (
                selfCheckInKioskApi: SelfCheckInKioskApi,
                dataService: Meevo.Components.CommonClasses.ICommonDataService,
                appSettings: Meevo.Components.Common.IAppSettings,
                $q: ng.IQService,
                modalService: Meevo.Components.Modal.IModalService,
                identityService: Meevo.Components.Common.IIdentityService
            ) => {
                return new SelfCheckInKioskLogic(
                    selfCheckInKioskApi,
                    dataService,
                    appSettings,
                    $q,
                    modalService,
                    identityService
                );
            };

            instance.$inject = [
                'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskApi',
                'meevo.components.common.DataService',
                'meevo.AppSettings',
                '$q',
                'meevo.components.modal.ModalService',
                'meevo.components.common.IdentityService',
            ];

            return instance;
        }

        constructor(protected selfCheckInKioskApi: SelfCheckInKioskApi,
                    protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $q: ng.IQService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService) {
            this._clientIds = [];
            this.promotionImagesSrc = [];
            this.clientDataToCheckin = [];
            this.enhancementsCount = 0;
            this.lateCheckInMin = 0;
        }

        reset(): void {
            this.clientPhone = null;
            this.clientEmail = null;
            this.enhancementsCount = 0;

            this._clientIds.length = 0;
            this.clientDataToCheckin = [];
        }

        searchForClient(data: { phone?: string; countryCode?: string; email?: string; }): ng.IPromise<void> {
            this._clientIds.length = 0;

            return this.selfCheckInKioskApi
                .getClientInfo(data)
                .then((responseData) => {
                    this._clientIds = [
                        responseData.clientId,
                        ...(responseData.possibleClients || []).map((possibleClient) => possibleClient.id)
                    ].filter((row) => typeof row === 'string');

                    if (this._clientIds.length === 0) {
                        throw new Error('LABEL_SELF_CHECK_IN_KIOSK_CLIENT_NOT_FOUND');
                    }
                });
        }

        loadClients(): ng.IPromise<IDataToCheckInEntity[]> {
            return this.$q.all(this.clientIds.map((clientId) => {
                return this.dataService
                    .customMethodData(`${this.appSettings.API_ROOT}/client/${clientId}`, 'GET', null)
                    .then(({ data }) => {
                        this.clientDataToCheckin.push(new DataToCheckInEntity(data, this.kioskSettings));
                    });
            }))
                .then(() => this.clientDataToCheckin);
        }

        updateClientsData(): ng.IPromise<void[]> {
            return this.$q.all(this.clientDataToCheckin.map((dataToCheckInEntity: IDataToCheckInEntity) => {
                return this.dataService
                    .customMethodData(`${this.appSettings.API_ROOT}/client/${dataToCheckInEntity.client.id}`, 'GET', null)
                    .then(({ data }) => {
                        dataToCheckInEntity.client = { ...dataToCheckInEntity.client, ...data };
                    });
            }));
        }

        loadAppointments(): ng.IPromise<void> {

            return this.$q.all(this.clientDataToCheckin.map((dataToCheckInEntity: IDataToCheckInEntity) => {
                return this.selfCheckInKioskApi
                    .getAppointmentsList(dataToCheckInEntity.client.id, this.lateCheckInMin)
                    .then((appointments) => {
                        return this.selfCheckInKioskApi.getCurrentTime().then(({ locationTime }) => {
                            dataToCheckInEntity.setAppointments(appointments, locationTime, this.lateCheckInMin);
                        });
                    });
            })).then(() => {
                this.clientDataToCheckin = this.clientDataToCheckin.filter((dataToCheckInEntity) => dataToCheckInEntity.validToCheckIn);

                if (this.clientDataToCheckin.length === 0) {
                    throw new Error(this.kioskSettings.unsuccessfulCheckinMessage);
                }
            });
        }

        loadSettings() {
            this.selfCheckInKioskApi
                .getSelfCheckinSettings()
                .then((settgins) => {
                    this._kioskSettings = settgins;
                    this.promotionImagesSrc.length = 0;
                    this.lateCheckInMin = settgins.clientCheckinLateThreshold;

                    if (settgins.promotionalContent1.meevoFile) {
                        this.promotionImagesSrc.push(settgins.promotionalContent1.meevoFile.files[0].fileUrl);
                    }

                    if (settgins.promotionalContent2.meevoFile) {
                        this.promotionImagesSrc.push(settgins.promotionalContent2.meevoFile.files[0].fileUrl);
                    }

                    if (settgins.promotionalContent3.meevoFile) {
                        this.promotionImagesSrc.push(settgins.promotionalContent3.meevoFile.files[0].fileUrl);
                    }

                    if (this.promotionImagesSrc.length === 0) {
                        // ship with placeholder images
                        this.promotionImagesSrc.push(
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg',
                            '../../../../assets/images/sck_placeholder.svg'
                        );
                    }

                    this.processPromotionalImages();
                });
        }

        processPromotionalImages() {

            // place images in separate arrays for portrait (2x) and landscape (3x) views
            const newArr1 = [];
            const newArr2 = [];

            for (let i = 0; i < this.promotionImagesSrc.length; i += 2) {
                newArr1.push(this.promotionImagesSrc.slice(i, i + 2));
            }

            for (let i = 0; i < this.promotionImagesSrc.length; i += 3) {
                newArr2.push(this.promotionImagesSrc.slice(i, i + 3));
            }

            this.promotionImagesSrcx2 = newArr1;
            this.promotionImagesSrcx3 = newArr2;
        }

        loadAdditionalEnhancements(): ng.IPromise<any> {
            return this.$q.all(this.clientDataToCheckin.map((checkinData) => {
                return this.$q.all(checkinData.appointmentServicesToCheckIn.map((checkInDataRow) => {
                    const employeeId = (checkInDataRow.appointmentService.employeeId || "").toString();
                    return this.selfCheckInKioskApi
                        .getServiceEnhancements(
                            checkInDataRow.appointmentService.serviceId.toString(),
                            employeeId
                        )
                        .then(({ addOnGroups, addOnServices }) => {
                            checkInDataRow.numberRequiredAddOns = addOnGroups
                                .reduce((sum, addOnGroup) => sum + addOnGroup.numberAddOnsRequired, 0);

                            checkInDataRow.hasRequiredAddOns = checkInDataRow.numberRequiredAddOns > 0;

                            // filter addons by the services to check-in
                            // addons that are as services to check in should not be included to the list for the same client
                            addOnServices = addOnServices
                                .filter((addon) => addon.employeePerformsService)
                                .filter((addon) => {
                                    return checkinData.allServiceIdsToCheckIn.indexOf(addon.serviceId) === -1
                                });

                            this.enhancementsCount += addOnServices.length;

                            return this.$q.all([
                                this.updateServiceAddOnsPrices(
                                    addOnServices,
                                    checkinData.client.id,
                                    employeeId,
                                ),
                                this.updatePriorVisitAtLocation(
                                    addOnServices,
                                    checkinData.client.id
                                )
                            ]).then(() => {
                                checkInDataRow.hasPreviouslyPurchased = addOnServices.some(addOn => addOn.hasPriorVisitAtLocation);
                                checkInDataRow.enhancements.push(
                                    ..._(addOnServices).sortBy(addOn => addOn.displayName.toLowerCase())
                                );
                            })

                        });
                }));

            }));
        }

        updatePriorVisitAtLocation(addOnServices: (IAddOnService & IHasPriorVisitAtLocation)[], clientId: string): ng.IPromise<(IAddOnService & IHasPriorVisitAtLocation)[]> {
            const serviceIds = _(addOnServices).pluck('serviceId');
            const serviceWithPriorVisitUnpagedListRequest = {
                clientId: clientId,
                serviceIds: serviceIds
            }

            return this.selfCheckInKioskApi
                .getServiceWithPriorVisit(
                    clientId,
                    serviceWithPriorVisitUnpagedListRequest
                )
                .then((serviceWithPriorVisitAtLocationList) => {
                    for (const addOn of addOnServices) {
                        addOn.hasPriorVisitAtLocation = serviceWithPriorVisitAtLocationList.length > 0
                            && !!_.findWhere(serviceWithPriorVisitAtLocationList, { serviceId: addOn.serviceId });
                    }

                    return addOnServices;
                })
        }

        updateServiceAddOnsPrices(addOnServices: IAddOnService[], clientId: string, employeeId: string): ng.IPromise<IAddOnService[]> {
            const addOnPriceRequests = addOnServices.map(addOn => ({
                serviceId: addOn.serviceId,
                employeeId,
                clientId
            }));

            return this.selfCheckInKioskApi
                .getRegisterPriceList(addOnPriceRequests)
                .then(({ services }) => {
                    addOnServices.forEach(addOn => {
                        addOn.price = services
                            .find(addOnPrice => {
                                return addOnPrice.priceRequest.serviceId === addOn.serviceId
                            }).finalPriceCharge;
                    });

                    return addOnServices;
                });
        }

        checkinData(): ng.IPromise<void[]> {
            return this.$q.all(this.clientDataToCheckin.map((dataToCheckInEntity) => {
                return this.selfCheckInKioskApi
                    .checkinToAppointment(
                        dataToCheckInEntity.appointmentId,
                        dataToCheckInEntity.appointmentCheckInData
                    );
            }));
        }

        checkExistIntakeForm(): ng.IPromise<boolean> {
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.clientIntakeForm}/Exists`, 'POST', {
                businessType_TId: this.identityService.businessTypeId
            })
                .then((res) => !!res.data && res.data.exists)
                .catch(() => false);
        }
    }


    angular.module('meevo.plugins.selfCheckInKiosk')
        .service('meevo.plugins.selfCheckInKiosk.SelfCheckInKioskLogic', SelfCheckInKioskLogic.factory());
}
